
export const API_KEY = 'pk.eyJ1IjoiZGV2dGVhbWFyZ2VudGluYSIsImEiOiJjbGdjZTl5ZTAwNmMyM3NteG5kbW01YzJmIn0.ru7RkO04bEzoGRmekPWExw';
